import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.session_assets_v2');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-session_assets_v2',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.session_assets_v2/view.scss */
/* src/app/component.session_assets_v2/view.scss: no such file or directory */`],
})
export class ComponentSession_assets_v2Component implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default ComponentSession_assets_v2Component;